module.exports = __webpack_public_path__ + "5d857a253c31a67a535f1a2f648646a6.jpg";